"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieStorage = void 0;
const Cookies = require("js-cookie");
class CookieStorage {
    constructor() {
        this.DOMAIN = '.booninterior.com';
        if (typeof window !== 'undefined' && !window.location.host.includes('booninterior.com')) {
            this.DOMAIN = null;
        }
    }
    getItem(key) {
        if (typeof window !== 'undefined') {
            return Cookies.get(key);
        }
        return null;
    }
    setItem(key, value, expiration = 30) {
        if (typeof window !== 'undefined') {
            Cookies.set(key, value, {
                domain: this.DOMAIN,
                expires: expiration,
                path: '/',
                secure: window.location.protocol === 'https:',
            });
        }
        return null;
    }
    removeItem(key) {
        if (typeof window !== 'undefined') {
            Cookies.remove(key, {
                domain: this.DOMAIN,
                path: '/',
                secure: window.location.protocol === 'https:',
            });
        }
        return null;
    }
}
exports.CookieStorage = CookieStorage;
